// extracted by mini-css-extract-plugin
export default {"infos":"Infos_infos__6S4EK","smallerFont":"Infos_smallerFont__NRIBc","bold":"Infos_bold__-kW6k"};